import { render, staticRenderFns } from "./billDetails.vue?vue&type=template&id=e4f00d64&scoped=true"
import script from "./billDetails.vue?vue&type=script&lang=js"
export * from "./billDetails.vue?vue&type=script&lang=js"
import style0 from "./billDetails.vue?vue&type=style&index=0&id=e4f00d64&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f00d64",
  null
  
)

export default component.exports